import AppState, { POPUPS, SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import classes from './ScreenEnd.module.css';

// import HomeScreens from '@scr/_layouts/HomeScreens/HomeScreens';
// import Config from 'react-sdk/Config';
import PopupsManager from 'react-sdk/PopupsManager';
import SoundPlayer from 'react-sdk/SoundPlayer';
import SaveGame from '@/js/SaveGame';
import CanvasCharacter from '@/components/Dial/CanvasCharacter/CanvasCharacter';
import Logo from '@/components/shared/Logo/Logo';
import Footer from '@/components/shared/Footer/Footer';
import AudioButton from '@/components/Hud/AudioButton/AudioButton';


const ScreenEnd = () => {


 
  function menuBtnClicked() {
    
    AppState.setScreen(SCREENS.MODULES)

  }
  function infoBtnClicked() {
    
    //AppState.setScreen(SCREENS.MODULES)

  }

  return (
    <div className={classes.ScreenEnd}>
      <div className={classes.header}>
        <Logo />
      </div>
      <div className={classes.content} >

        <div className={classes.title} dangerouslySetInnerHTML={{__html: Texts.get("end-title") }}/>
        <div className={classes.text} dangerouslySetInnerHTML={{__html: Texts.get("end-content") }}/>

        <div className={classes.buttons_cntr}>
          <Button className={classes.menu_btn} onClick={menuBtnClicked} name="menuButton">
            {Texts.get("end-button-menu")}
          </Button>
          {/*<Button className={classes.infos_btn} onClick={infoBtnClicked} name="infosButton">
            {Texts.get("end-button-infos")}
          </Button>*/}
        </div>

      </div>

      <CanvasCharacter char_id="chef_chantier" attitude="satisfaction" />
      <Footer />
    </div>

  );
};

export default  observer(ScreenEnd)
